// extracted by mini-css-extract-plugin
module.exports = {"info":"styles-module--info--AqAic"};